import { render, staticRenderFns } from "./toBeAttr.vue?vue&type=template&id=10ba22d4&scoped=true&"
import script from "./toBeAttr.vue?vue&type=script&lang=js&"
export * from "./toBeAttr.vue?vue&type=script&lang=js&"
import style0 from "./toBeAttr.vue?vue&type=style&index=0&id=10ba22d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba22d4",
  null
  
)

export default component.exports